import { UserController } from '../../controllers';
import { appStore, useStores } from '../../stores';
import { MimaToastUtil } from '../../components';
import { Security } from '../../pages/Settings';
import { number, object, string } from 'yup';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';

const SecurityContainer = ({ closeModal }) => {
	const [passwordChange, setPasswordChange] = useState(false);
	const [pinChange, setPinChange] = useState(false);
	const [pinSet, setPin] = useState(false);
	const [loading, setLoading] = useState(false);

	let {
		userStore,
	} = useStores();

	const goBack = () => {
		if (pinChange) {
			setPinChange(false);
		} else if (passwordChange) {
			setPasswordChange(false);
		} else if (pinSet) {
			setPin(false);
		} else {
			closeModal();
		}
	};

	const hasPin = userStore.user.hasPin;

	const changePasswordValidationSchema = () =>
		object({
			newPassword: string().required('Enter the new password value'),
			password: string().required('Enter the password value'),
			confirmNewPassword: string()
				.required('Enter the new confirm password value')
				.test(function() {
					const { newPassword, confirmNewPassword } = this.parent;
					return newPassword !== confirmNewPassword
						? this.createError({
								message:
									'New password and confirm new password should be the same',
								path: 'confirmNewPassword',
						  })
						: true;
				}),
		});

	const changePinValidationSchema = () =>
		object({
			password: string().required('Enter the password value'),
			secretAnswer: string().required('Enter your answer to the secret'),
			newPin: number()
				.required('Enter the new pin value')
				.max(9999)
				.min(1000),
		});

	const setPinValidationSchema = () =>
		object({
			password: string().required('Enter the password value'),
			secretQuestion: string().required('Select a secret question'),
			secretAnswer: string().required('Enter your answer to the secret'),
			pin: number()
				.required('Enter the new pin value')
				.max(9999)
				.min(1000),
		});

	const onSubmitChangePin = async payload => {
		appStore.setLoading(true);
		const { status, errorMessage } = await UserController.changePin({
			password: payload.password,
			newPin: payload.newPin,
			secretAnswer: payload.secretAnswer,
		});

		appStore.setLoading(false);
		if (status === constant.Success) {
			MimaToastUtil.success({
				message: constant.Success,
			});
		} else {
			MimaToastUtil.error({
				message: errorMessage,
			});
		}
		closeModal();
	};

	const onSubmitSetPin = async payload => {
		appStore.setLoading(true);
		const { status, errorMessage } = await UserController.setPin({
			password: payload.password,
			pin: payload.pin,
			secretQuestion: payload.secretQuestion,
			secretAnswer: payload.secretAnswer,
		});

		appStore.setLoading(false);
		if (status === constant.Success) {
			MimaToastUtil.success({
				message: constant.Success,
			});
			return userStore.setLoggedIn(false);
		} else {
			MimaToastUtil.error({
				message: errorMessage,
			});
		}
		closeModal();
	};

	const onSubmitChangePassword = async payload => {
		setLoading(true);
		const { newPassword, password } = payload;
		const { status, errorMessage } = await UserController.changePassword({
			password,
			newPassword,
		});
		setLoading(false);
		if (status === constant.Success) {
			MimaToastUtil.success({
				message: constant.Success,
			});
			// return goToPasswordChangeSuccess();
			return closeModal();
		}

		MimaToastUtil.error({
			message: errorMessage,
		});
	};

	const goToPasswordChange = () => {
		setPinChange(false);
		setPasswordChange(true);
		setPin(false);
	};

	const goToPasswordChangeSuccess = () => {
		setPasswordChange(false);
		setPinChange(false);
	};

	const goToPinChange = () => {
		setPinChange(true);
		setPasswordChange(false);
		setPin(false);
	};
	const goToSetPin = () => {
		setPin(true);
		setPasswordChange(false);
		setPinChange(false);
	};

	return (
		<Security
			securityQuestions={appStore.securityQuestions}
			onSubmitChangePin={onSubmitChangePin}
			onSubmitSetPin={onSubmitSetPin}
			hasPin={hasPin}
			closeModal={closeModal}
			changePinValidationSchema={changePinValidationSchema}
			loading={loading}
			goToPasswordChange={goToPasswordChange}
			onSubmitChangePassword={onSubmitChangePassword}
			goToPinChange={goToPinChange}
			setPinValidationSchema={setPinValidationSchema}
			pinSet={pinSet}
			goToSetPin={goToSetPin}
			passwordChange={passwordChange}
			changePasswordValidationSchema={changePasswordValidationSchema}
			pinChange={pinChange}
			goBack={goBack}
		/>
	);
};

export default SecurityContainer;
